/* ==========================================================================
   EVOTIQUE — strat de mișcare
   Portat din conceptul de prezentare. Tot ce e aici e decorativ: dacă
   scriptul nu rulează, pagina rămâne complet funcțională și lizibilă.
   Se stinge integral la prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     1. INTRO — sigiliu 3D. Doar pe prima pagină și doar o dată per
     sesiune: repetat la fiecare navigare ar fi enervant.
     --------------------------------------------------------------- */
  function intro() {
    var el = document.getElementById('evo-intro');
    if (!el) return;

    var vazut = false;
    try { vazut = sessionStorage.getItem('evo-intro-vazut') === '1'; } catch (e) {}

    if (reduce || vazut) { el.parentNode.removeChild(el); return; }
    try { sessionStorage.setItem('evo-intro-vazut', '1'); } catch (e) {}

    document.documentElement.style.overflow = 'hidden';

    var inchis = false;
    function inchide() {
      if (inchis) return;
      inchis = true;
      el.classList.add('gata');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 1100);
    }
    setTimeout(inchide, 4400);
    var skip = el.querySelector('.evo-intro-skip');
    if (skip) skip.addEventListener('click', inchide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Enter') inchide();
    });
  }

  /* ---------------------------------------------------------------
     2. DEZVĂLUIRE PE RÂNDURI REALE
     Împart titlul în cuvinte, citesc unde cade fiecare după layout,
     apoi regrupez cuvintele de pe același rând într-o mască proprie.
     Așa funcționează la orice lățime, fără tăieturi hardcodate.
     --------------------------------------------------------------- */
  function facLinii(h) {
    var text = (h.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    h.setAttribute('data-text', text);

    var cuvinte = text.split(' ');
    h.textContent = '';
    var probe = [];
    cuvinte.forEach(function (c, i) {
      var s = document.createElement('span');
      s.textContent = c;
      h.appendChild(s);
      if (i < cuvinte.length - 1) h.appendChild(document.createTextNode(' '));
      probe.push(s);
    });

    var randuri = [], ultim = null;
    probe.forEach(function (s) {
      var top = s.offsetTop;
      if (ultim === null || Math.abs(top - ultim) > 4) { randuri.push([]); ultim = top; }
      randuri[randuri.length - 1].push(s.textContent);
    });

    h.textContent = '';
    randuri.forEach(function (r) {
      var ln = document.createElement('span');
      ln.className = 'ln';
      var it = document.createElement('i');
      it.textContent = r.join(' ');
      ln.appendChild(it);
      h.appendChild(ln);
    });
  }

  function linii() {
    var tinte = document.querySelectorAll('.evo-linii');
    if (!tinte.length) return;
    Array.prototype.forEach.call(tinte, facLinii);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        Array.prototype.forEach.call(tinte, function (h) {
          var text = h.getAttribute('data-text');
          if (!text) return;
          h.textContent = text;
          facLinii(h);
          h.classList.add('in');   // deja văzut, nu-l re-ascundem
        });
      }, 220);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------
     3. REVEAL LA DERULARE — refolosește .evo-reveal din temă
     --------------------------------------------------------------- */
  function reveal() {
    var tinte = document.querySelectorAll('.evo-reveal, .evo-linii');
    if (!tinte.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(tinte, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (intrari) {
      intrari.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    Array.prototype.forEach.call(tinte, function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     4. BARĂ DE PROGRES
     --------------------------------------------------------------- */
  function progres() {
    var bar = document.createElement('div');
    bar.className = 'evo-progres';
    document.body.appendChild(bar);
    var raf = null;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
      });
    }, { passive: true });
  }

  /* ---------------------------------------------------------------
     5. LUMINĂ CARE URMĂREȘTE CURSORUL PE CARDURI
     --------------------------------------------------------------- */
  function lumina() {
    document.querySelectorAll('.evo-cat-card').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------------------------------------------------------------
     6. CÂMP DE DIFUZIE — particule aurii care se ridică lent.
     Canvas, nu SVG: e o grafică generativă, nu o formă fixă.
     Bucla se oprește când hero-ul iese din ecran.
     --------------------------------------------------------------- */
  function haze() {
    var cv = document.getElementById('evo-haze');
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var parts = [], W = 0, H = 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var raf = null, activ = true;

    function dimensiune() {
      var r = cv.getBoundingClientRect();
      W = r.width; H = r.height;
      if (!W || !H) return;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      parts = [];
      var n = Math.round(Math.min(44, Math.max(14, W / 28)));
      for (var i = 0; i < n; i++) {
        parts.push({
          x: Math.random() * W, y: Math.random() * H,
          r: 18 + Math.random() * 72,
          vy: 0.06 + Math.random() * 0.19,
          vx: (Math.random() - 0.5) * 0.13,
          a: 0.018 + Math.random() * 0.044,
          ph: Math.random() * Math.PI * 2
        });
      }
    }

    function cadru(t) {
      if (!activ) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.vy;
        p.x += p.vx + Math.sin(t / 3400 + p.ph) * 0.15;
        if (p.y + p.r < 0) { p.y = H + p.r; p.x = Math.random() * W; }
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        g.addColorStop(0, 'rgba(201,162,39,' + p.a + ')');
        g.addColorStop(1, 'rgba(201,162,39,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      }
      raf = requestAnimationFrame(cadru);
    }

    dimensiune();
    window.addEventListener('resize', dimensiune, { passive: true });
    raf = requestAnimationFrame(cadru);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var vizibil = e[0].isIntersecting;
        if (vizibil && !activ) { activ = true; raf = requestAnimationFrame(cadru); }
        else if (!vizibil && activ) { activ = false; cancelAnimationFrame(raf); }
      }, { threshold: 0.02 }).observe(cv);
    }
  }

  /* ---------------------------------------------------------------
     pornire
     --------------------------------------------------------------- */
  function start() {
    intro();
    linii();
    reveal();
    if (reduce) return;
    progres();
    lumina();
    haze();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   Galerie de produs — comutare între fotografii.
   Separat de blocul principal, ca să ruleze și dacă restul e dezactivat de
   prefers-reduced-motion: schimbarea imaginii e funcțională, nu decorativă.
   ========================================================================== */
(function () {
  'use strict';
  function initGalerie() {
    var thumbs = document.querySelectorAll('.evo-pd-thumb');
    if (!thumbs.length) return;
    var imgs = document.querySelectorAll('.evo-pd-img');

    function arata(i) {
      imgs.forEach(function (im) { im.classList.toggle('activ', +im.dataset.index === i); });
      thumbs.forEach(function (t) {
        var activ = +t.dataset.index === i;
        t.classList.toggle('activ', activ);
        t.setAttribute('aria-selected', activ ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { arata(+t.dataset.index); });
      t.addEventListener('keydown', function (e) {
        // săgeți stânga/dreapta între miniaturi, ca la un set de file
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var i = +t.dataset.index;
        var urm = e.key === 'ArrowRight' ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length;
        thumbs[urm].focus();
        arata(urm);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalerie);
  else initGalerie();
})();
